module.exports = __webpack_public_path__ + "img/metamask_rtv.9632db65.jpg";